import isNil from 'lodash/isNil';
import { useTranslation } from 'react-i18next';

import { Entity } from '@/comp/MapBuilder/nodes/nodeWidget/NodeWidget.types';

const ControllableIndication = ({ entity }: { entity: Entity }) => {
  const { t } = useTranslation();
  const { controlMode } = entity;

  return (
    !isNil(controlMode) && (
      <div className="remote-control">
        <span className="remote-control-text">
          {controlMode === 'controllable' ? t('remoteControlSupported') : t('remoteControlUnsupported')}
        </span>
      </div>
    )
  );
};

export default ControllableIndication;
